import { render, staticRenderFns } from "./SubMerchantList.vue?vue&type=template&id=aada6586&scoped=true"
import script from "./SubMerchantList.vue?vue&type=script&lang=js"
export * from "./SubMerchantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aada6586",
  null
  
)

export default component.exports